import { useEffect, useRef } from "react";

/**
 * Hook réutilisable pour infinite scroll avec IntersectionObserver
 * Story 2.4: AC3 - Chargement automatique de la page suivante
 */
export const useInfiniteScroll = (
  onLoadMore: () => void,
  hasMore: boolean,
  isLoading: boolean
) => {
  const sentinelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const first = entries[0];
        if (first.isIntersecting && hasMore && !isLoading) {
          onLoadMore();
        }
      },
      {
        threshold: 0.5, // Trigger when 50% of sentinel is visible
        rootMargin: "0px 0px 200px 0px", // Preload 200px before reaching sentinel
      }
    );

    observer.observe(sentinel);

    return () => {
      observer.disconnect();
    };
  }, [onLoadMore, hasMore, isLoading]);

  return sentinelRef;
};
